﻿﻿export interface IMatchHistoryRecipient {
    recipientId: number;
    matchHistoryId: number;
}
